import React from 'react';
import BottomTabNav from '../shared/components/BottomTabNav';
import Footer from '../shared/components/Footer';
import './CustomerContact.css';

const CustomerContact = () => {

  return (
    <div className="App">
      <div className="contact-container">
        <div className="contact-content">
          {/* Header */}
          <div className="contact-header">
            <h1 className="contact-title">Contact ZepEat</h1>
            <p className="contact-subtitle">We're here to help! Get in touch with us</p>
          </div>

          {/* Contact Methods */}
          <div className="contact-section">
            <h2 className="section-title">Get In Touch</h2>
            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">📞</div>
                <div className="method-info">
                  <h3>Phone Support</h3>
                  <p>+1 (555) 123-4567</p>
                  <span>Available 24/7</span>
                </div>
              </div>
              <div className="contact-method">
                <div className="method-icon">📧</div>
                <div className="method-info">
                  <h3>Email Support</h3>
                  <p>support@zepeat.com</p>
                  <span>Response within 2 hours</span>
                </div>
              </div>
              <div className="contact-method">
                <div className="method-icon">💬</div>
                <div className="method-info">
                  <h3>Live Chat</h3>
                  <p>Available on our app</p>
                  <span>Instant support</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information Details */}
          <div className="contact-section">
            <h2 className="section-title">How to Reach Us</h2>
            <div className="contact-details-grid">
              <div className="contact-detail-card">
                <div className="contact-detail-icon">📞</div>
                <div className="contact-detail-content">
                  <h3>Call Us Directly</h3>
                  <p className="contact-number">+1 (555) 123-4567</p>
                  <p className="contact-description">Our customer support team is available 24/7 to assist you with any questions or concerns.</p>
                  <div className="contact-features">
                    <span className="feature-tag">✅ Immediate Support</span>
                    <span className="feature-tag">✅ Order Assistance</span>
                    <span className="feature-tag">✅ Technical Help</span>
                  </div>
                </div>
              </div>

              <div className="contact-detail-card">
                <div className="contact-detail-icon">📧</div>
                <div className="contact-detail-content">
                  <h3>Email Support</h3>
                  <p className="contact-email">support@zepeat.com</p>
                  <p className="contact-description">Send us detailed inquiries and we'll respond within 2 hours during business hours.</p>
                  <div className="contact-features">
                    <span className="feature-tag">✅ Detailed Responses</span>
                    <span className="feature-tag">✅ Account Issues</span>
                    <span className="feature-tag">✅ Feedback & Suggestions</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Office Information */}
          <div className="contact-section">
            <h2 className="section-title">Visit Our Office</h2>
            <div className="office-info">
              <div className="office-card">
                <div className="office-icon">🏢</div>
                <div className="office-details">
                  <h3>ZepEat Headquarters</h3>
                  <p className="office-address">
                    123 Food Street<br />
                    City Center, Downtown<br />
                    New York, NY 10001
                  </p>
                  <div className="office-hours">
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 9:00 AM - 9:00 PM</p>
                    <p>Saturday: 10:00 AM - 8:00 PM</p>
                    <p>Sunday: 11:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="contact-section">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3>How can I track my order?</h3>
                <p>You can track your order in real-time through the "My Orders" section in the app or website.</p>
              </div>
              <div className="faq-item">
                <h3>What if my order is delayed?</h3>
                <p>If your order is significantly delayed, please contact our support team for immediate assistance.</p>
              </div>
              <div className="faq-item">
                <h3>How do I cancel an order?</h3>
                <p>Orders can be cancelled within 5 minutes of placement through the app or by calling our support line.</p>
              </div>
              <div className="faq-item">
                <h3>What payment methods do you accept?</h3>
                <p>We accept all major credit cards, debit cards, digital wallets, and cash on delivery.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer websiteType="customer" />
      <BottomTabNav />
    </div>
  );
};

export default CustomerContact;
